import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { getStore } from './store';
import VueGoogleCharts from 'vue-google-charts';
import moment from 'moment';
import VueNoty from 'vuejs-noty';
import VCalendar from 'v-calendar';
import { securityService } from './tools/sequrity_service';
import AccessibilityPlugin from './plugins/accessibility';
import './static/js/jquery.js';
import './static/js/uhpv-full.js';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import PortalVue from 'portal-vue';
import { getJwt } from './tools/http';
import process from 'process';

// GraphQl Apollo
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createApolloProvider } from '@vue/apollo-option';

// Сюда прописываем эндпойнт к API

const httpLink = createHttpLink({
    uri: `https://recruitment-search.${window.rsvDomain}/graphql`,
});

const httpLinkProject2 = createHttpLink({
    uri: `https://projects2.${window.rsvDomain}/graphql`,
});

// Реализуем кэш
const cache = new InMemoryCache();

// Данные авторизации
const authLink = setContext((_, { headers }) => {
    const jwt = getJwt();

    return {
        headers: {
            ...headers,
            authorization: jwt ? `Bearer ${jwt}` : '',
        },
    };
});

// Инициализуерм клиент Аполло
const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
});

const apolloClientProject2 = new ApolloClient({
    link: authLink.concat(httpLinkProject2),
    cache: new InMemoryCache(),
});

Vue.use(VueApollo);

// Создаем провайдер
const apolloProvider = createApolloProvider({
    clients: {
        apolloClient: apolloClient,
        apolloClientProject2: apolloClientProject2,
    },
    defaultClient: apolloClient,
});

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faTrash,
    faCalendar,
    faBell,
    faList,
    faGripLines,
    faImages,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faSignOutAlt,
    faCheck,
    faTimes,
    faPaperPlane,
    faAngleDown,
    faAngleRight,
    faAngleLeft,
    faArrowLeft,
    faArrowUp,
    faLink,
    faHome,
    faTrophy,
    faUserGraduate,
    faBriefcase,
    faStreetView,
    faPen,
    faSearch,
    faSortDown,
    faMapMarkerAlt,
    faGlobe,
    faFrown,
    faMeh,
    faSmile,
    faEye,
    faEyeSlash,
    // faVk,
} from '@fortawesome/free-solid-svg-icons';

import {
    faFrown as faRegFrown,
    faMeh as faRegMeh,
    faSmile as faRegSmile,
} from '@fortawesome/free-regular-svg-icons';

import {
    faVk,
    faInstagram,
    faFacebookF,
    faYoutube,
    faOdnoklassniki,
    faTwitter,
    faTelegram,
    faTelegramPlane,
} from '@fortawesome/free-brands-svg-icons';

// filters
import dmy from './filters/dmy.filter';
import fullDate from './filters/full-date.filter';
import fullIsoDate from './filters/full-iso-date.filter';
import numbers from './filters/numbers.filter';
import timestampTime from './filters/timestamp-time.filter';
import timestampFullDate from './filters/timestamp-date.filter';
import timestampWithTime from './filters/timestamp-with-time.filter';
import isoWithTime from './filters/iso-with-time.filter';
import phone from './filters/phone.filter';
import ellipsis from './filters/ellipsis.filter';
import cutString from './filters/cut-string.filter';
import capitalize from './filters/capitalize.filter';
import priceWithSpaces from './filters/price-with-spaces.filter';
import { countdownTimer, maskedTel } from './tools/filters';

let environment = 'development';
if (process.env) {
    if (process.env.NODE_SENTRY_ENV) {
        environment = process.env.NODE_SENTRY_ENV;
    } else if (process.env.NODE_ENV) {
        environment = process.env.NODE_ENV;
    }
}
/*
Sentry.init({
    Vue,
    dsn: window.sentryUrl,
    environment,
    integrations: [
        new BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});
*/

Vue.filter('countdownTimer', countdownTimer);
Vue.filter('maskedTel', maskedTel);
// mixins
import mainMixin from './assets/mixins/mainMixin';

library.add(
    faTrash,
    faCalendar,
    faBell,
    faList,
    faGripLines,
    faImages,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faSignOutAlt,
    faCheck,
    faTimes,
    faHome,
    faVk,
    faInstagram,
    faFacebookF,
    faYoutube,
    faOdnoklassniki,
    faTwitter,
    faTelegram,
    faTelegramPlane,
    faPaperPlane,
    faAngleDown,
    faAngleRight,
    faAngleLeft,
    faArrowLeft,
    faLink,
    faTrophy,
    faUserGraduate,
    faArrowUp,
    faBriefcase,
    faStreetView,
    faChevronDown,
    faPen,
    faSearch,
    faSortDown,
    faMapMarkerAlt,
    faGlobe,
    faFrown,
    faMeh,
    faSmile,
    faRegFrown,
    faRegMeh,
    faRegSmile,
    faEye,
    faEyeSlash
);

import swipe from './tools/swipe';
import Loading from './directives/loading';
import ClickOutside from './directives/click-outside';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

Vue.use(VueTelInput);
Vue.use(AccessibilityPlugin, {
    store: new AccessibilityPlugin.Store().setup(),
});
// Vue.use(tinymceMin);

Vue.use(VueGoogleCharts);
Vue.use(VueNoty, {
    timeout: 3000,
    progressBar: false,
    theme: 'bootstrap-v4',
});

Vue.use(VCalendar, {
    componentPrefix: 'vc', // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(PortalVue);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.filter('ellipsis', ellipsis);
Vue.filter('dmy', dmy);
Vue.filter('fullDate', fullDate);
Vue.filter('fullIsoDate', fullIsoDate);
Vue.filter('numbers', numbers);
Vue.filter('timestampFullDate', timestampFullDate);
Vue.filter('timestampWithTime', timestampWithTime);
Vue.filter('isoWithTime', isoWithTime);
Vue.filter('timestampTime', timestampTime);
Vue.filter('phone', phone);
Vue.filter('cutString', cutString);
Vue.filter('capitalize', capitalize);
Vue.filter('priceWithSpaces', priceWithSpaces);

Vue.directive('swipe', swipe);
Vue.directive('loading', Loading);
Vue.directive('click-outside', ClickOutside);

Vue.mixin(mainMixin);

Vue.config.productionTip = false;

Vue.prototype.moment = moment;
Vue.prototype.ellipsis = ellipsis;

const globalData = {
    securityService,
};

const globalMethods = {};

let vueInstanse = new Vue({
    router,
    apolloProvider,
    data: globalData,
    methods: globalMethods,
    store: getStore(),
    render: (h) => h(App),
}).$mount('#app');

export default vueInstanse;
